/**
 * Solvane scroll reveal — deliberately tiny.
 *
 * Adds .is-in to [data-sv-reveal] elements as they enter the viewport, once.
 * The observer disconnects per-element after firing, so there is no ongoing
 * scroll cost.
 *
 * Guardrails:
 *  · Only transform + opacity are animated, so this can never cause layout
 *    shift. No CLS penalty.
 *  · Honours prefers-reduced-motion: everything is revealed immediately and no
 *    observer is created at all.
 *  · The .sv-js class is set inline in theme.liquid <head>, so without JS the
 *    hiding rule never applies and all content is visible. Progressive
 *    enhancement, not a dependency.
 */
(function () {
  var els = document.querySelectorAll('[data-sv-reveal]');
  if (!els.length) return;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();
